<template>
    <div
        class="tw:flex tw:items-center tw:gap-2 tw:px-2 tw:py-1 tw:rounded-full tw:text-xs tw:font-bold tw:border"
        :class="[variantClasses.container, customClass]"
    >
        <i v-if="icon" class="material-icons tw:text-xs tw:leading-none">{{ icon }}</i>
        <div
            v-else-if="dot"
            class="tw:w-1.5 tw:h-1.5 tw:rounded-full tw:flex-shrink-0"
            :class="variantClasses.dot"
        ></div>
        <p class="tw:m-0 tw:p-0 tw:leading-none tw:inline">{{ label }}</p>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        label:       { type: String, default: '' },
        variant:     { type: String, default: 'default' },
        dot:         { type: Boolean, default: true },
        icon:        { type: String, default: null },
        customClass: { type: String, default: '' },
    });

    const variantClasses = computed(() => {
        const map = {
            success: {
                container: 'tw:bg-green-50 tw:text-green-700 tw:border-green-100',
                dot:       'tw:bg-green-500',
            },
            danger: {
                container: 'tw:bg-red-50 tw:text-red-700 tw:border-red-100',
                dot:       'tw:bg-red-500',
            },
            warning: {
                container: 'tw:bg-yellow-50 tw:text-yellow-700 tw:border-yellow-100',
                dot:       'tw:bg-yellow-500',
            },
            info: {
                container: 'tw:bg-cyan-50 tw:text-cyan-700 tw:border-cyan-100',
                dot:       'tw:bg-cyan-500',
            },
            default: {
                container: 'tw:bg-slate-50 tw:text-slate-500 tw:border-slate-200',
                dot:       'tw:bg-slate-400',
            },
        };
        return map[props.variant] ?? map.default;
    });
</script>
